import { BaseRequest, IBaseRequest } from "../../BaseRequest";

export interface IDeleteMessageContainerNotificationRequest extends IBaseRequest {
  id: string;
}

export class DeleteMessageContainerNotificationRequest
  extends BaseRequest
  implements IDeleteMessageContainerNotificationRequest
{
  public id: string;

  constructor(server: string, session: string, id: string) {
    super(server, session);
    this.id = id;
  }

  public toXml(): string {
    let parameters = super.toXml();
    parameters += this.makeNode(this.id, "id");
    return super.wrapperXml("DeleteMessageContainerNotification", parameters);
  }
}

